<template>
  <div class="production-workbench">
    <!-- 欢迎标题 -->
    <div class="welcome">
      <div class="welcome-content">
        <div class="welcome-text">Hi，欢迎回来，{{ userName }}！</div>
        <el-select
          v-model="warehouseId"
          placeholder="请选择仓库"
          @change="changeWarehouse"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </div>

    <!-- 人效数据 -->
    <div class="human-efficiency">
      <div class="human-efficiency-left">
        <div class="finish-order">
          <p class="content">{{ todayFinishOrderNums }}</p>
          <p class="title">今日完成订单（单）</p>
          <p class="footer-conter">
            昨日完成订单（单）：{{ yesterdayFinishOrderNums }}
          </p>
        </div>

        <div class="actual-area">
          <p class="content">{{ actualArea }}</p>
          <p class="title">实占面积（㎡）</p>
          <p class="footer-conter">空仓面积（㎡）：{{ emptyWarehouseArea }}</p>
        </div>
      </div>
      <div class="human-efficiency-right">
        <div class="more">
          <span class="sub-title">人效数据</span>
          <el-button class="btn-text" type="text" @click="toEfficiencyReport"
            >查看更多</el-button
          >
        </div>
        <p class="echart-title">单位：件/小时/人</p>
        <div
          id="humanEfficiency"
          :style="{ width: '100%', height: '100%' }"
        ></div>
      </div>
    </div>

    <!-- 各页面数据统计 -->
    <div class="statistics">
      <div
        v-for="(item, index) in statisticsList"
        :key="index"
        class="statistics-datails"
      >
        <div class="name">
          <div class="name-text">
            <img class="name-sign" :src="item.img" />
            {{ item.name }}
          </div>
          <img
            class="no-finish"
            v-if="item.isOpenStatus"
            src="~assets/images/product/no-finish.png"
          />
        </div>
        <div class="statistics-content">
          <div class="statistics-content-left">
            <div class="page-title">
              <span class="page-content">{{ item.pageName }}</span>
              <span class="go-to" @click="toUrl(item.keyWord, item.pageUrl)">前往</span>
            </div>
            <p class="update-time">上次更新时间：{{ item.date }}</p>
            <p
              class="foot-content"
              :class="{ 'red-circle': item.isOpenFootRedCircle }"
              v-if="item.footLeftTitle"
            >
              {{ item.footLeftTitle }}：{{ item.footLeftContent }}
            </p>
          </div>
          <div class="statistics-content-right">
            <div class="page-title" v-if="item.isShowRightGoto">
              <span
                class="page-content"
                :class="{ 'red-circle': item.isOpenRightRedCircle }"
                >{{ item.pageName2 }}</span
              >
              <span
                v-if="item.name === '库存作业'"
                class="go-to"
                @click="openAbnormal"
                >前往</span
              >
              <span v-else class="go-to" @click="toUrl(item.keyWord2, item.pageUrl2)"
                >前往</span
              >
            </div>
            <div class="page-title" v-else>
              <span
                class="page-content"
                :class="{ 'red-circle': item.isOpenRightRedCircle }"
                >{{ item.pageName2 }}</span
              >
            </div>
            <div class="nums" v-if="item.name !== '退货作业'">
              {{ item.nums }}
            </div>
            <p class="update-time" v-else>上次更新时间：{{ item.date2 }}</p>
            <p class="foot-content" v-if="item.footRightTitle">
              {{ item.footRightTitle }}：{{ item.footRightContent }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductionWorkbench from "models/production/production-workbench.js";
import warehouseMixins from "@/common/mixins/warehouse.js";
import { getDBUserRealName, getUserAuth } from "@/common/js/storage";
import { formatTimeToDate, formatTimeToMonthAndDay, numsToRMBSymbolAndMillimeter } from "common/js/util";
export default {
  mixins: [warehouseMixins],

  data() {
    return {
      // 仓库id
      warehouseId: null,
      // 用户名称
      userName: "",
      // 今日完成单量
      todayFinishOrderNums: '-',
      // 昨日完成单量
      yesterdayFinishOrderNums: '-',
      // 实占面积
      actualArea: '-',
      // 空仓面积
      emptyWarehouseArea: '-',
      // 统计数据
      statisticsList: [],
    };
  },

  async created() {
    this.userName = getDBUserRealName();
    await this.initAsyncWarehouse();
    this.warehouseId = this.warehouseList[0].id;
    this.initStatisticsData();
  },

  mounted() {
    this.initHumanEfficiencyData();
  },

  methods: {
    changeWarehouse() {
      this.initStatisticsData();
    },

    /**
     * @desc 获取人效数据
     */
    initHumanEfficiencyData() {
      let data = {
        warehouseId: this.warehouseId,
      };

      let res = {
        success: true,
        result: {
          list: [
            {
              time: 1680480000000,
              value: 120,
              orderNum: 120,
              nums: 3740,
              mixedProduct: 3741,
              sameProduct: 3742,
            },
            {
              time: 1680566400000,
              value: 274,
              orderNum: 274,
              nums: 3007,
              mixedProduct: 3008,
              sameProduct: 3009,
            },
            {
              time: 1680652800000,
              value: 345,
              orderNum: 345,
              nums: 3576,
              mixedProduct: 3578,
              sameProduct: 3579,
            },
            {
              time: 1680739200000,
              value: 255,
              orderNum: 255,
              nums: 2345,
              mixedProduct: 2346,
              sameProduct: 2347,
            },
            {
              time: 1680825600000,
              value: 235,
              orderNum: 235,
              nums: 2865,
              mixedProduct: 2866,
              sameProduct: 2867,
            },
            {
              time: 1680912000000,
              value: 325,
              orderNum: 325,
              nums: 2498,
              mixedProduct: 2499,
              sameProduct: 2500,
            },
            {
              time: 1680998400000,
              value: 212,
              orderNum: 212,
              nums: 3953,
              mixedProduct: 3954,
              sameProduct: 3955,
            },
          ],
        },
      };
      // ProductionWorkbench.getHumanEfficiencyData(data).then(res => {
      if (res.success) {
        let { list } = res.result;
        let xData = ['04-01','04-01','04-01','04-01','04-01','04-01'];
        let seriesArr = [0,0,0,0,0,0];
        // list.map((i) => {
        //   let obj = {};
        //   obj.value = i.value;
        //   obj.orderNum = i.orderNum;
        //   obj.nums = i.nums;
        //   obj.mixedProduct = i.mixedProduct;
        //   obj.sameProduct = i.sameProduct;
        //   obj.date = formatTimeToDate(i.time);
        //   let monthAndDay = formatTimeToMonthAndDay(i.time);
        //   xData.push(monthAndDay);
        //   seriesArr.push(obj);
        // });
        this.initHumanEfficiency(xData, seriesArr);
      } else {
        this.$message.error(res.message);
      }
      // })
    },
    
    /** 
     * @desc 获取各页面统计数据
    */
    initStatisticsData() {
      let data = {
        warehouseId: this.warehouseId,
      };
      ProductionWorkbench.getStatisticsData(data).then(res => {
        if (res.success) {
          let { 
            inventoryOperationsResVo, extraServiceResVo, employeeCostResVo, 
            bulkResVo, unloadingResVo, refundResVo, employeePerformanceDataResVo 
          } = res.result
          
          // 实占面积
          this.actualArea = employeePerformanceDataResVo.useArea?employeePerformanceDataResVo.useArea:'-'
          // 空仓面积
          this.emptyWarehouseArea = employeePerformanceDataResVo.freeArea?employeePerformanceDataResVo.freeArea:'-'

          // isOpenStatus: 是否展示未完成状态；isOpenRightRedCircle: 是否展示右边小红点；isShowRightGoto：是否展示右边前往
          // footLeftTitle：底部左边标题；footLeftContent：底部左边内容；footRightTitle：底部右边标题；footRightContent：底部右边内容；
          // keyWord: 左边前往页面权限；keyWord2: 右边前往页面权限；
          // pageName：左边标题；pageName2：右边标题
          // pageUrl：左边调整路径；pageUrl2：右边跳转路径
          // date：左边更新时间；date2：右边更新时间
          let arr = [
            {
              name: "库存作业",
              keyWord: 'PRODUCTION_inventory_job_real_occupied_area_input',
              img: require("../../../../assets/images/product/warehouse-sign.png"),
              isOpenStatus: inventoryOperationsResVo.unmaintainedWeightItem?true:false,
              pageName: "实占面积录入",
              pageUrl: "/production/inventory-operation/real-area",
              date: inventoryOperationsResVo.lastImportUseAreaDate,
              pageName2: "未维护重量商品",
              nums: inventoryOperationsResVo.unmaintainedWeightItem,
              isOpenRightRedCircle: inventoryOperationsResVo.unmaintainedWeightItem?true:false,
              isShowRightGoto: true,
            },
            {
              name: "增值服务",
              keyWord: 'PRODUCTION_value_added_services_operation',
              img: require("../../../../assets/images/product/add-sign.png"),
              isOpenStatus: false,
              pageName: "增值服务登记",
              pageUrl: "/production/increment/increment-operation",
              date: extraServiceResVo.lastExtraServiceDate,
              pageName2: "本月已产生增值金额",
              nums: numsToRMBSymbolAndMillimeter(extraServiceResVo.amountInThisMonth),
              isOpenRightRedCircle: false,
              isShowRightGoto: false,
            },
            {
              name: "人力资源",
              keyWord: 'PRODUCTION_resource_management_the_human_cost',
              img: require("../../../../assets/images/product/manpower-sign.png"),
              isOpenStatus: false,
              pageName: "人力成本",
              pageUrl: "/production/resource-manage/labor-cost",
              date: employeeCostResVo.lastEmployeeCostDate,
              pageName2: "",
              nums: "",
              isOpenRightRedCircle: false,
              isShowRightGoto: false,
            },
            {
              name: "发货作业",
              keyWord: 'PRODUCTION_delivery_job_operation',
              keyWord2: 'PRODUCTION_delivery_job_team_manager',
              img: require("../../../../assets/images/product/send-sign.png"),
              isOpenStatus: bulkResVo.noBulkNum?true:false,
              pageName: "大宗出库登记",
              pageUrl: "/production/bulk/bulk-operation",
              date: bulkResVo.lastBulkDate,
              pageName2: "已入驻班组",
              pageUrl2: "/production/bulk/team/team-details",
              nums: bulkResVo.numInTeam,
              isOpenRightRedCircle: false,
              isOpenFootRedCircle: bulkResVo.noBulkNum?true:false,
              isShowRightGoto: true,
              footLeftTitle: "未完成大宗登记",
              footLeftContent: bulkResVo.noBulkNum,
            },
            {
              name: "收货作业",
              keyWord: 'PRODUCTION_receive_job_receiving_operation',
              img: require("../../../../assets/images/product/income-sign.png"),
              isOpenStatus: false,
              pageName: "收货登记",
              pageUrl: "/production/receiving/receiving-operation",
              date: unloadingResVo.lastUnloadingDate,
              pageName2: "今日到货客户",
              nums: unloadingResVo.customerNumToday,
              isOpenRightRedCircle: false,
              isShowRightGoto: false,
            },
            {
              name: "退货作业",
              keyWord: 'PRODUCTION_return_of_the_homework_return_of_the_registration',
              keyWord2: 'PRODUCTION_return_of_the_homework_any_returns',
              img: require("../../../../assets/images/product/return-sign.png"),
              isOpenStatus: false,
              pageName: "退货登记",
              pageUrl: "/production/return-operation/return-register",
              date: refundResVo.lastRefundRegisterDate,
              pageName2: "退货处理",
              pageUrl2: "/production/return-operation/return-processing",
              nums: "",
              date2: refundResVo.lastRefundDate,
              isOpenRightRedCircle: false,
              isShowRightGoto: true,
              footLeftTitle: "在途退货运单",
              footLeftContent: refundResVo.numInTransit,
              footRightTitle: "今日已完成退货",
              footRightContent: refundResVo.numInFinishToday,
            },
          ];
          this.statisticsList = arr;
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /**
     * @desc 前往效率报表
     */
    toEfficiencyReport() {
      if (getUserAuth().indexOf('DATA_REPORT_efficiency_report') !== -1) {
        this.$router.push({
          path: "/home/efficiency-report-index/efficiency-report",
        });
      } else {
        this.$message.error('暂无权限')
      }
    },

    /**
     * @desc 创建折线图
     */
    initHumanEfficiency(xData, seriesArr) {
      let initEchart = this.$echarts.init(
        document.getElementById("humanEfficiency")
      );
      initEchart.setOption({
        grid: {
          top: "20px",
          left: "5%",
          right: "1%",
        },
        tooltip: {
          trigger: "item",
          // 额外附加到浮层的 css 样式
          extraCssText:
            "width: 218px; height: 160px;padding: 8px;box-sizing: border-box;border: 1px solid #FFFFFF;box-shadow: 0px 3px 12px 1px rgba(0,27,85,0.16);background: rgba(255,255,255,0.3); backdrop-filter: blur(15px);",
          // 自定义
          formatter: function (params) {
            // data为数据
            let { data } = params;
            // html
            let contentHtml = `<p style="height: 32px;line-height: 32px; font-size: 14px;font-family: 'PingFang SC-Heavy, PingFang SC';font-weight: 800;color: #303030;">${data.date}</p>
                                <div style="background: #fff;border-radius: 4px; display: flex; justify-content: flex-start; align-items: center;flex-wrap: wrap;">
                                  <div style="width: 100px; height: 56px;display: flex; justify-content: center; align-items: center; flex-direction: column;">
                                    <p style="font-size: 14px;font-family: 'PingFang SC-Heavy, PingFang SC';font-weight: 800;color: #303030;margin-bottom: 4px;">${data.orderNum}</p>
                                    <p style="font-size: 14px;font-family: 'PingFang SC-Regular, PingFang SC';font-weight: 400;color: #B4B4B4;">总单量</p>
                                  </div>
                                  <div style="width: 100px; height: 56px;display: flex; justify-content: center; align-items: center; flex-direction: column;">
                                    <p style="font-size: 14px;font-family: 'PingFang SC-Heavy, PingFang SC';font-weight: 800;color: #303030;margin-bottom: 4px;">${data.nums}</p>
                                    <p style="font-size: 14px;font-family: 'PingFang SC-Regular, PingFang SC';font-weight: 400;color: #B4B4B4;">总件数</p>
                                  </div>
                                  <div style="width: 100px; height: 56px;display: flex; justify-content: center; align-items: center; flex-direction: column;">
                                    <p style="font-size: 14px;font-family: 'PingFang SC-Heavy, PingFang SC';font-weight: 800;color: #303030;margin-bottom: 4px;">${data.mixedProduct}</p>
                                    <p style="font-size: 14px;font-family: 'PingFang SC-Regular, PingFang SC';font-weight: 400;color: #B4B4B4;">混品件数</p>
                                  </div>
                                  <div style="width: 100px; height: 56px;display: flex; justify-content: center; align-items: center; flex-direction: column;">
                                    <p style="font-size: 14px;font-family: 'PingFang SC-Heavy, PingFang SC';font-weight: 800;color: #303030;margin-bottom: 4px;">${data.sameProduct}</p>
                                    <p style="font-size: 14px;font-family: 'PingFang SC-Regular, PingFang SC';font-weight: 400;color: #B4B4B4;">同品件数</p>
                                  </div>
                                </div>`;
            return contentHtml;
          },
        },
        xAxis: {
          type: "category",
          data: xData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: seriesArr,
            type: "line",
            // 将小圆点改成实心，不写symbol默认为空心
            symbol: "circle",
            // 折线颜色
            color: "#1890FF",
            // 折线下的渐变阴影
            areaStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    // 0%初的颜色
                    color: "rgba(24,144,255,0.2)",
                  },
                  {
                    offset: 1,
                    // 100%初的颜色
                    color: "rgba(255,255,255,0.1)",
                  },
                ],
                // 缺省为false
                globalCoord: true,
              },
            },
          },
        ],
      });
    },

    toUrl(keyword, url) {
      if (getUserAuth().indexOf(keyword) !== -1) {
        this.$router.push({
          path: url,
        });
      } else {
        this.$message.error('暂无权限')
      }
    },

    /**
     * @desc 开启异常订单抽屉
     */
    openAbnormal() {
      this.$bus.emit("openAbnormalDrawer", "commodityWeightAlertNotMaintained");
    },
  },
};
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/production-workbench.scss";
</style>
